import { mutatorAction } from "satcheljs";
import { getItem } from "owa-local-storage";
import { trace } from "owa-trace";
import getMyOutlookViewState from "../store/myOutlookViewState";

export function isMyOutlookFullPageShowing(): boolean {
    return getMyOutlookViewState().isFullPageShowing;
}

export function shouldShowMyOutlookReadingPane(isFullPageShowing: boolean, isProductEnabled: boolean, isSearchTableShown: boolean, isMultipleSelection: boolean, isComposeOrSecondaryReadingPaneTab: boolean): boolean {
    return (isFullPageShowing &&
        isProductEnabled &&
        !isSearchTableShown &&
        !isMultipleSelection &&
        !isComposeOrSecondaryReadingPaneTab);
}

const SECTION_HIDDEN_KEY = "owa-personal-os-section-hidden";
let sectionHiddenHydrated = false;

const hydrateSectionHiddenMutator = mutatorAction("hydrateSectionHiddenMutator", (): void => {
    try {
        getMyOutlookViewState().isSectionHidden = getItem(self, SECTION_HIDDEN_KEY) === "true";
    }
    catch {
        trace.warn("MyOutlookAppearancePreferenceReadFailed");
    }
});

export function isMyOutlookSectionHidden(): boolean {
    if (!sectionHiddenHydrated) {
        sectionHiddenHydrated = true;
        hydrateSectionHiddenMutator();
    }
    return getMyOutlookViewState().isSectionHidden;
}
